import {
  Component,
  EventEmitter,
  Input,
  Output,
  forwardRef,
} from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { ControlValueAccessorDirective } from '@sharedModule/directives/control-value-accessor.directive';
import { InputData } from '@sharedModule/models/input-data.model';

@Component({
  selector: 'app-input-template',
  templateUrl: './input-template.component.html',
  styleUrls: ['./input-template.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputTemplateComponent),
      multi: true,
    },
  ],
})
export class InputTemplateComponent<
  T,
> extends ControlValueAccessorDirective<T> {
  @Input() inputData?: InputData;
  @Output() passwordChanged = new EventEmitter<string>();
  @Output() inputChange = new EventEmitter<string | number>();
  hide = true;

  generatePassword(): void {
    const password = Array(10)
      .fill(
        '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz~!@-#$'
      )
      .map(x => {
        return x[Math.floor(Math.random() * x.length)];
      })
      .join('');
    this.passwordChanged.emit(password);
  }

  onInput(event: Event): void {
    this.inputChange.emit((event.target as HTMLInputElement).value);
  }
}
